export function animate(element, properties = [], { duration = 0, easing = 'ease-in-out', delay = 0 }) {
    const computedStyle = getComputedStyle(element);

    const commitStyles = () => {
        for(const [property, value] of Object.entries(properties)) {
            element.style.setProperty(property, value);
        }
    };

    /* Check for Web Animations API support. If unsupported,
     * commit styles directly without animation.
     */
    if(!Element.prototype.animate) {
        commitStyles();
        return;
    }

    /* Support for single keyframes is very limited, so
     * we dynamically generate the first keyframe based
     * on the computed style of each proeprty.
     */
    const from = Object.entries(properties).map(([property, value]) => {
        return [property, computedStyle[property]];
    });

    /* As with CSS transitions, Web Animations do not support
     * transitioning to `auto` height, so wen need to compute
     * that value first.
     */
    const to = Object.entries(properties).map(([property, value]) => {
        if(property === 'height' && value === 'auto') {
            value = `${ element.scrollHeight }px`;
        }

        return [property, value];
    });

    const frames = [from, to].map(frame => Object.fromEntries(frame));
    const animation = element.animate(frames, { duration, easing, delay });

    /* Persist styles after the animation finishes. This can be done as
     * soon as the animation starts, as styles during an animation take
     * precendence of inline styles.
     */
    const timeout = setTimeout(() => commitStyles(), delay);

    /* In case the animation is cancelled before it has started, do
     * not persist styles. */
    animation.oncancel = () => clearTimeout(timeout);

    return animation;
}
